import React, { Fragment } from 'react'
import { Duration } from 'luxon'
import { Helmet } from 'react-helmet'

import Component from 'components/component'
import Image from 'components/image'
import VideoPlayer from 'components/video-player'
import { ViewStatus } from 'pages/content/lives/live-status'
import { formatDuration } from 'helpers/date'
import { DI } from 'modules'
import * as config from 'config'
import * as routes from '../../../../config/routes'

import './style.css'

const PLAYBACK_RATES = [1, 1.5, 2, 2.5]

export class ViewVideoPlayer extends Component {
  static defaultProps = {
    entity: {},
    isLive: false,
    isOnLive: false,
    time: '',
  }

  state = {
    showStopButton: false,
    playing: false,
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  playPause = () => this.setState(prev => ({ playing: !prev.playing }))

  onMouseLeave = () => this.setState({ showStopButton: false })

  onMouseMove = () => {
    clearTimeout(this.timeout)

    this.setState({
      showStopButton: this.props.isLive,
    })

    this.timeout = setTimeout(this.onMouseLeave, 3000)
  }

  componentDidMount() {
    this.playPause()
    setTimeout(this.playPause, 20)
  }

  componentDidUpdate(prevProps) {
    const status = this.props.entity.status
    const prevStatus = prevProps.entity.status

    if (status !== prevStatus && status === 'finished') {
      this.setState({
        playing: false,
      })
    }
  }

  render() {
    const { entity, isLive, className, isOnLive, time, common } = this.props
    const isHls = this.previewUrl && this.previewUrl.includes('m3u8')
    const videoJsOptions = {
      autoplay: true,
      controls: true,
      sources: [
        {
          src: this.previewUrl,
          type: isLive || isHls ? 'application/x-mpegURL' : 'video/mp4',
        },
      ],
      key: this.previewUrl,
      watermark: this.props.watermark,
      format: entity.format,
      className: `live__img live__img--${entity.status}`,
      style: { userSelect: 'none' },
      playbackRates: !isLive && PLAYBACK_RATES,
    }

    const showDuration = Boolean(
      !this.state.playing && !isLive && entity.duration
    )

    const showPlayPauseControl = Boolean(
      this.state.playing ? this.state.showStopButton : this.previewUrl
    )

    const GoogleScheme_Img = isLive
      ? [
          entity.image.large_brand.url,
          entity.image.thumbnail.url,
          entity.image.v273x154.url,
          entity.image.v575x323.url,
          entity.image.v960x540.url,
          entity.image.url,
        ]
      : [
          entity.selected_preview_image.large.url,
          entity.selected_preview_image.large_brand.url,
          entity.selected_preview_image.medium.url,
          entity.selected_preview_image.small.url,
          entity.selected_preview_image.url,
        ]

    const GoogleScheme_Published = isLive
      ? entity.start_at
      : entity.published_at
    const isRecordings =
      entity.cutting_available && entity.status === 'finished'

    return (
      <div
        className={this.classList(
          'live-image',
          className,
          isLive ? 'is-live' : 'is-vidio'
        )}
        onMouseMove={this.onMouseMove}
        onMouseLeave={this.onMouseLeave}
      >
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'VideoObject',
              'name': entity.title,
              'description': entity.description,
              'thumbnailUrl': GoogleScheme_Img,
              'uploadDate': isLive ? entity.start_at : entity.published_at,
              'duration': entity.duration
                ? Duration.fromMillis(entity.duration).toISO()
                : void 0,
              'contentUrl': this.previewUrl,
              'publication': isLive
                ? {
                    '@type': 'BroadcastEvent',
                    'name': entity.title,
                    'isLiveBroadcast': true,
                    'startDate': entity.start_at,
                    'endDate': entity.end_at || undefined,
                  }
                : void 0,
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'NewsArticle',
              'headline': entity.title,
              'image': GoogleScheme_Img,
              'datePublished': GoogleScheme_Published,
              'dateModified': entity.updated_at,
              'author': {
                '@type': 'Organization',
                'name': `${common.strings['site.company']}`,
                'url': config.VOD_HOST,
              },
            })}
          </script>
          {(entity.tags || []).length > 0 && (
            <script type="application/ld+json">
              {JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                'itemListElement': entity.tags.map((tag, i) => ({
                  '@type': 'ListItem',
                  'position': i + 1,
                  'name': tag.name,
                  'item':
                    config.VOD_HOST +
                    (isLive
                      ? routes.landing.getPath(null, tag.slug)
                      : routes.videosFilter.getPath(
                          common.locale,
                          tag.state === 'regular' ? 'tag' : 'category',
                          `${tag.id}-${tag.name}`
                        )),
                })),
              })}
            </script>
          )}
        </Helmet>
        <div className="live-img">
          {this.state.playing && entity.downloadable !== 'retracted' ? (
            <VideoPlayer {...videoJsOptions} />
          ) : (
            <Image
              url={this.props.preview}
              title={entity.title}
              render={({ url }) => (
                <Fragment>
                  {isLive && (
                    <p
                      style={{
                        position: 'absolute',
                        zIndex: 10,
                        padding: '20px',
                        color: '#fff',
                      }}
                    >
                      {entity.stock_photo_credit}
                    </p>
                  )}

                  <span className="live__img">
                    <img src={url} alt={entity.title} />
                  </span>
                  {/* {entity.limit_type === 'pool' && (
                        <Tooltip content={strings['page.video.left.pool.info']}>
                            <span className="live__mark">{`Pool ${strings['page.lives.view.pool_description']}`}</span>
                        </Tooltip>
                    )} */}
                </Fragment>
              )}
            />
          )}
          {isLive && (
            <ViewStatus
              cuttingAvailable={entity.cutting_available}
              status={entity.status}
              tbc={entity.start_at_not_finalized}
              live={entity}
              isOnLive={isOnLive}
              time={isRecordings ? entity.recording_access_till : time}
            />
          )}
          {showDuration && <DurationVideo duration={entity.duration} />}
          {showPlayPauseControl && entity.downloadable !== 'retracted' && (
            <span
              onClick={this.playPause}
              className={this.classList(
                'live__play',
                this.state.playing && '_stop'
              )}
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>
      </div>
    )
  }

  get previewUrl() {
    const { entity, isLive } = this.props

    if (!isLive) return entity.preview_url

    const allowStatus = ['next', 'live']
    const lang =
      entity.languages.find(
        lang => lang.id === this.props.selectedLanguageID
      ) ||
      entity.languages[0] ||
      {}

    if (allowStatus.includes(entity.status) && lang.preview_target) {
      return lang.preview_target.hls_playback_url
    }
    return null
  }
}

function DurationVideo({ duration }) {
  return <span className="live__duration">{formatDuration(duration)}</span>
}

export default DI(['common'])(ViewVideoPlayer)
